import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface TitleCardProps {
  title: string;
  isFirst?: boolean;
}

export function ColumnTitleCard({ title, isFirst = undefined }: TitleCardProps) {
  return (
    <div className={`col-span-1 xl:col-span-1 flex h-[100px] ml-3${isFirst ? '' : ' justify-center'}`}>
      <Typography variant="h6">
        <FormattedMessage id={title} />
      </Typography>
    </div>
  );
}
